import { jsx as _jsx } from "react/jsx-runtime";
import CheckIcon from "@mui/icons-material/Check";
import { Box } from "@mui/material";
export const ColorSwatchPicker = ({ colors, value, onChange, }) => (_jsx(Box, { sx: { display: "flex", flexWrap: "wrap", gap: 1 }, children: colors.map((hex) => {
        const selected = value?.toLowerCase() === hex.toLowerCase();
        return (_jsx(Box, { component: "button", type: "button", "aria-label": hex, "aria-pressed": selected, onClick: () => onChange(hex), sx: {
                width: 28,
                height: 28,
                p: 0,
                borderRadius: "50%",
                bgcolor: hex,
                cursor: "pointer",
                boxShadow: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: (theme) => `2px solid ${selected ? theme.palette.text.primary : "transparent"}`,
            }, children: selected && (_jsx(CheckIcon, { sx: { fontSize: 16, color: "#fff", mixBlendMode: "difference" } })) }, hex));
    }) }));
